import { action, Action } from 'typesafe-actions'

import {
  DocumentosAssinaturaTypes,
  FinalizarPropostaPayload,
  type DocumentosAssinaturaState,
} from './types'

type DocumentosAssinaturaPayload = DocumentosAssinaturaState['documentos']

export const setDocumentos = (payload: DocumentosAssinaturaPayload): Action =>
  action(DocumentosAssinaturaTypes.SET_DOCUMENTOS, payload)

export const setIdIteracao = (payload: string): Action =>
  action(DocumentosAssinaturaTypes.SET_ID_ITERACAO, payload)

export const setDocumentoRevisao = (payload: string): Action =>
  action(DocumentosAssinaturaTypes.SET_DOCUMENTO_REVISAO, payload)

export const setCheckMessageRevisao = (payload: string): Action =>
  action(DocumentosAssinaturaTypes.SET_CHECK_MESSAGE_REVISAO, payload)

export const setTitleDocumentoRevisao = (payload: string): Action =>
  action(DocumentosAssinaturaTypes.SET_TITLE_DOCUMENTO_REVISAO, payload)

export const setLoading = (payload: boolean): Action =>
  action(DocumentosAssinaturaTypes.SET_LOADING, payload)

export const finalizarProposta = (payload: FinalizarPropostaPayload): Action =>
  action(DocumentosAssinaturaTypes.FINALIZAR_PROPOSTA, payload)

export const finalizarPropostaSuccess = (): Action =>
  action(DocumentosAssinaturaTypes.FINALIZAR_PROPOSTA_SUCCESS)

export const finalizarPropostaErro = (): Action =>
  action(DocumentosAssinaturaTypes.FINALIZAR_PROPOSTA_ERROR)
